import React from 'react';
import PropTypes from 'prop-types';
import CollapsiblePanel from 'components/CollapsiblePanel';
import './UserSupport.scss';



export default class UserSupport extends React.Component {
    constructor (props) {
        super(props);
    }

    render() {

        const installationFAQ= [
            {
                question:'Can you install NOON switches on 3-way, or 4-way circuit?',
                answer: 'Yes, But all switches on the circuit will need to be replaced with NOON switches.',
            },
            {
                question: 'Does the NOON switch require a Neutral wire?',
                answer: 'Yes, NOON switches require both Neutral and Ground wires to work. For more information, read this article.',
            },
            {
                question: 'What is a maximum supported wattage on a NOON switch?',
                answer: 'NOON products can support up to 500W for incandescent bulbs in a single-switch configuration. For other bulb types and when installed in 2- and 3-gang configurations, read this article.',
            },
            {
                question: 'Do the NOON Room Director and Extension switches need to be on the same circuit to work?',
                answer: 'No, NOON switches communicate on/off and dimming status of lights with one another via Bluetooth Low Energy (BLE). The Room director can communicate with up to 10 Extension switches wirelessly, across as many circuits as those 11 switches control.',
            },
            {
                question: 'What bulb types is NOON compatible with?',
                answer: 'NOON switches are compatible with both dimmable and non-dimmable LED, Incandescent, Halogen, CFL and Fluorescent bulbs. However, for a layered lighting experience, dimmable bulbs are highly recommended. For more information, read this article.',
            },
            {
                question: 'Can you replace a switch that controls a fan, light/fan combo, switched outlet or appliance with a NOON switch?',
                answer: 'No, NOON switches should control lights only.',
            },
            {
                question: 'Do you sell different SKUs for single-pole, 3-way and 4-way switches?',
                answer: 'No, our NOON switches are universal, and can be installed in a single pole, 3-way and 4-way configuration.',
            },
            {
                question: "Do you need a different SKU depending on which fixture or bulb type you're installing with?",
                answer: 'No. NOON switches are universal dimmers. They can be installed on, and will work with, any common type of fixture and bulb. During setup, our proprietary bulb discovery mechanism will configure the switch to work with the bulb and fixtures they’ve been installed to work with.',
            },
            {
                question: 'Where is the best location to install the Room Director?',
                answer: 'We recommend placing the Director in an easily accessible switch location, as this will serve as the main hub of activity for your room and scene control. For more details on where we recommend placing our Director, check out Where to install the Room Director.',
            },
            {
                question: 'What happens if my home network, or internet, go down?',
                answer: 'The beauty of the NOON lighting system is that it will continue to work, regardless of whether your home network, or internet go down. The Room Director will continue to communicate with the Extension switches its been associated with and control lights as expected until the internet is brought back up again. During that time, the only limitation is that you won\'t be able to control your lights via the App.',
            }

        ];

        const multiWayFAQ = [
            {
                question: 'Can the Room Director be on separate circuit than 2 or more Extension in a Multi-way?',
                answer: 'Yes, as long as both Extensions are paired to the same Room Director in the same room.',
            },
            {
                question: 'Do both/all of my multi-way switches need to be in the same room, even though they are technically in different rooms',
                answer: 'No, all switches controlling the same multi-way circuit can be in different rooms but must be paired to the same Room Director.',
            },
            {
                question: 'If I dim on one extension, turn the lights off, then turn the lights on another extension, will my lights remember my dim level?',
                answer: 'Yes, the switch will remember the last dim level',
            },
            {
                question: 'Are these switches wired as serial or parallel circuits?',
                answer: 'NOON multi-way uses parallel circuits, each base needs to receive power to provide a charge to our switches.',
            },
            {
                question: 'Will these work if there is neutral at only one end of a 3-way?',
                answer: 'Yes, if you’re experienced in repurposing travelers you can repurpose one of the travelers in our 3-way setup to provide Neutral to both switch locations. If you’re not familiar with this method, we do not recommend attempting this.',
            },
            {
                question: 'What does "interchargeable line/load" mean?',
                answer: '“Interchangeable” means that it does not matter which line or load you connect to our black interchangeable line/load wires. Our internal circuitry determines whether we turn a light on or off.',
            },
            {
                question: 'How do the switches talk to each other in multiway? Which one is the master?',
                answer: 'NOON switches communicate over Bluetooth Low Energy (BLE) to communicate on/off and dimming status between the switches in a multi-way and you can use either a mix of Director & Extensions or just Extensions in a multi-way.',
            }
        ];

        const appsFAQ = [
            {
                question: 'How many switches can I add to one Room?',
                answer: '10 - 1 Room Director and 10 Extensions',
            },
            {
                question: 'What do I do if I have more than 10 switches in an Open Plan area?',
                answer: "You’ll need to choose how to split the room, with some switches paired to one Room Director and the others paired to a second/third/etc Room Director(s)",
            },
            {
                question: 'Can I have more than 1 Director in a room controlling the same set of lights?',
                answer: 'No, but you can control your room from any location by using the NOON app.',
            },
            {
                question: 'How do I controll juat one light in the app?',
                answer: 'You can use individual light control by using the temporary scene settings at the bottom of the scene screen in your NOON App. From here, you can dim any individual light or turn it off entirely from the app without affecting your saved scenes.',
            },
            {
                question: 'Can I controll all of my rooms in one click?',
                answer: 'Yes! From the home screen in your NOON app, click the Home icon, then select All On or All Off.',
            }
        ];

        const roomDFAQ = [
            {
                question: 'How do I controll the scenes on the screen?',
                answer: 'To change scenes swipe up or down on the touchscreen.',
            },
            {
                question: 'Where is the best location to install the Director?',
                answer: 'We recommend placing the Director in an easily accessible switch location, as this will serve as the main hub of activity for your room and scene control. For more details on where we recommend placing our Director, check out Where to install the Room Director on our site!',
            },
            {
                question: 'How do you dim from Director? Can you?',
                answer: 'You can dim from the Director by changing the scene on the director, if you want to dim only that light you can do so from the Noon app.',
            },
            {
                question: 'How long do I hold down the switch to pair?',
                answer: 'Hold down the switch until you see the LED on either the bottom of the Director, or between the dim buttons on the Extension go from rapid blinking to slow blinking and the app should indicate that it has begun pairing.',
            }
        ];



        return(
            <section className='support--container'>
                <h1>Get the help you need.</h1>
                <h6 className='FAQ--section'>Installation</h6>
                {installationFAQ.map((item, index) => (
                    <CollapsiblePanel key={index} panel={item}/>
                ))}

                <h6 className='FAQ--section'>Multi-Way</h6>
                {multiWayFAQ.map((item, index) => (
                    <CollapsiblePanel key={index} panel={item}/>
                ))}

                <h6 className='FAQ--section'>Apps</h6>
                {appsFAQ.map((item, index) => (
                    <CollapsiblePanel key={index} panel={item}/>
                ))}

                <h6 className='FAQ--section'>Room Director</h6>
                {roomDFAQ.map((item, index) => (
                    <CollapsiblePanel key={index} panel={item}/>
                ))}

                <div className='contact-info-container'>
                    <hr/>
                    <h4 className='contact-title'>Need help?</h4>
                    <p>Get in touch with NOON Support.</p>
                    <p>Call us at 1 833-232-2347 or email <a className='support-link' href="mailto:support@noonhome.com">support@noonhome.com.</a></p>
                    <p>We're available 5 days a week.</p>
                    <p>7:00 AM to 7:00 PM PT Monday to Friday</p>
                    <h4 className='contact-title'>Visit the NOON Support Tools</h4>
                    <p>Search Support for answers to common questions.</p>
                    <a className='support-link' href="https://www.noonhome.com/support" target="_blank">NOON Support</a>

                </div>

            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/routes/UserSupport/index.js